module.exports = __webpack_public_path__ + "media/members/member-feedback-empty-21c254e9.svg";